import { ColumnsType } from 'antd/lib/table';
import { InvoiceDto } from 'common/dto/generated/InvoiceDto';
import { InvoiceFilteredColumns } from './InvoiceColumns';

export const InvoiceIsPaperColumns: ColumnsType<InvoiceDto> = [
  InvoiceFilteredColumns.isPaper,
  { ...InvoiceFilteredColumns.issuedDate, fixed: 'left' },
  InvoiceFilteredColumns.expiresAt,
  InvoiceFilteredColumns.state,
  InvoiceFilteredColumns.supplierName,
  InvoiceFilteredColumns.supplierFiscal,
  InvoiceFilteredColumns.protocol,
  InvoiceFilteredColumns.issuedNumber,
  InvoiceFilteredColumns.invoiceTypeCode,
  InvoiceFilteredColumns.totalAmount
];
